export const ObjectUtils = {
  deleteUndefinedKey: (obj: Object) =>
    Object.entries(obj).reduce((p, [k, v]) => (v !== undefined && v !== null ? { ...p, [k]: v } : p), {}),
}
